import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { SupplierCredentialsPanel } from '../components/admin/SupplierCredentialsPanel';
import { Key, Database, RefreshCw } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const AdminSupplierCredentialsPage = () => {
  const { t } = useLanguage();
  const providers = 'Mobilax · JensMobiles · LCD-Phone';

  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 py-6 space-y-6" data-testid="admin-supplier-credentials-page">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <Key className="w-7 h-7 text-cyan-400" />
            <div>
              <h1 className="text-2xl font-bold text-white">{t('adminSupplierCreds.title')}</h1>
              <p className="text-sm text-gray-400 mt-1">
                {t('adminSupplierCreds.subtitle', { providers })}
              </p>
            </div>
          </div>
          <Link
            to="/admin/cache-fournisseurs"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-white/5 border border-white/10 text-gray-300 hover:bg-white/10 text-sm font-semibold"
          >
            <Database className="w-4 h-4 text-cyan-400" />
            {t('adminSupplierCreds.supplierData')}
            <RefreshCw className="w-3.5 h-3.5 text-gray-500" />
          </Link>
        </div>

        <SupplierCredentialsPanel variant="dark" />
      </div>
    </Layout>
  );
};

export default AdminSupplierCredentialsPage;
